import AppSidebar from 'components/AppSidebar';
import getFeatureFlag from 'utils/functions/getFeatureFlags';
import useShouldShowContestResult from 'utils/hooks/useShouldShowContestResult';
import styles from './SidebarLayout.module.scss';

interface OwnProps {
  children: React.ReactNode;
}

type SidebarLayoutProps = OwnProps;

function SidebarLayout({children}: SidebarLayoutProps) {
  const {shouldShowContestResult} = useShouldShowContestResult();
  const isC5FlagOn = getFeatureFlag('c5_banner').isOn;
  const isStudentRecommendationsAndAlertsOn = getFeatureFlag(
    'student_recommendations_and_alerts',
  ).isOn;
  const isEvolutionFlagOn = getFeatureFlag('evolution_portal').isOn;

  const showSidebar =
    isC5FlagOn ||
    isStudentRecommendationsAndAlertsOn ||
    shouldShowContestResult;

  return (
    <div
      className={`${styles.layout} ${showSidebar ? '' : styles.hideSidebar}`}
    >
      {showSidebar && (
        <AppSidebar
          isC5FlagOn={isC5FlagOn}
          isEvolutionFlagOn={isEvolutionFlagOn}
          isStudentRecommendationsAndAlertsOn={
            isStudentRecommendationsAndAlertsOn
          }
          shouldShowContestResult={shouldShowContestResult}
        />
      )}
      {children}
    </div>
  );
}

export default SidebarLayout;
